// Keep this list alphabetized — it drives the order of the sidebar nav in the data view.
export const dataResources = [
  'allergies',
  'careTeam',
  'conditions',
  'documents',
  'encounters',
  'familyHistory',
  'immunizations',
  'labOrders',
  'labs',
  'medications',
  'procedures',
  'serviceRequests',
  'socialHistory',
  'surveys',
  'vitals',
] as const;

export type DataResource = (typeof dataResources)[number];
